<template>
  <v-dialog v-model="showDialog" persistent max-width="550" :retain-focus="false">
    <template v-slot:activator="{ on }">
      <div class="d-flex flex-row align-center pointer" v-on="on">
        <!-- Mostramos el label y el icono según el modo -->
        <p class="shipping__discount text-center mr-2">
          {{ buttonInfo.label }}
        </p>
        <v-icon class="text-body-1 text-center">
          {{ buttonInfo.icon }}
        </v-icon>
      </div>
    </template>

    <v-card data-cy="modal-unlock-discounts">
      <v-card-title class="text-h3">{{ dialogContent.title }}</v-card-title>

      <v-card-text class="text-body-2 mt-4 mb-4">
        {{ dialogContent.description[0] }}
        <span class="bold">{{ dialogContent.description[1] }}</span>
      </v-card-text>

      <v-card-actions class="d-flex justify-end pa-4">
        <v-btn
          class="link non-text-transformation"
          id="cancel"
          color="black"
          outlined
          tile
          @click="showDialog = false"
        >
          {{ $t('UNLOCK_DISCOUNTS_MODAL_CANCEL') }}
        </v-btn>

        <v-btn
          class="link non-text-transformation"
          id="submit"
          color="primary"
          tile
          @click="onDialogAccept"
        >
          {{ dialogContent.acceptBtn }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'BlockDiscountsDialog',
  props: {
    mode: {
      type: String,
      default: 'hidden', // lock / unlock
    },
  },
  data() {
    return {
      showDialog: false,
    }
  },
  computed: {
    buttonInfo() {
      if (this.mode === 'unlock') {
        return {
          label: this.$t('SHIPPING_DISCOUNTS_UNLOCK'),
          icon: 'mdi-lock-open',
        }
      } else {
        // lock
        return {
          label: this.$t('SHIPPING_DISCOUNTS_LOCK'),
          icon: 'mdi-lock',
        }
      }
    },
    dialogContent() {
      if (this.mode === 'unlock') {
        return {
          title: this.$t('UNLOCK_DISCOUNTS_MODAL_TITLE'),
          description: [
            this.$t('UNLOCK_DISCOUNTS_MODAL_DESCRIPTION1'),
            this.$t('UNLOCK_DISCOUNTS_MODAL_DESCRIPTION2'),
          ],
          acceptBtn: this.$t('SHIPPING_DISCOUNTS_UNLOCK'),
        }
      } else {
        return {
          title: this.$t('LOCK_DISCOUNTS_MODAL_TITLE'),
          description: [
            this.$t('LOCK_DISCOUNTS_MODAL_DESCRIPTION1'),
            this.$t('LOCK_DISCOUNTS_MODAL_DESCRIPTION2'),
          ],
          acceptBtn: this.$t('SHIPPING_DISCOUNTS_LOCK'),
        }
      }
    },
  },
  methods: {
    onDialogAccept() {
      this.$emit('onChangeDiscountsLocked', this.mode)
      this.showDialog = false
    },
  },
}
</script>

<style scoped lang="scss">
.shipping {
  &__discount {
    width: 84px;
    margin-bottom: 5px;
    text-align: center;
    margin-right: 10px;
  }
}
.pointer {
  cursor: pointer;
}
</style>
